import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useDebounce } from '../hooks/useDebounce';

export default function SearchFilter({ onSearch, onFilter, filters = [] }) {
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  
  // Debounce search to reduce API calls
  const debouncedSearch = useDebounce(searchTerm, 500);
  
  // Call onSearch only when debounced value changes
  useEffect(() => {
    if (debouncedSearch !== undefined) {
      onSearch(debouncedSearch);
    }
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // onSearch will be called automatically via debounce
  };

  const handleFilter = (e) => {
    const value = e.target.value;
    setSelectedFilter(value);
    onFilter(value);
  };

  return (
    <div className="flex gap-4 mb-4">
      <div className="flex-1">
        <input
          type="text"
          placeholder={`${t('search')}...`}
          value={searchTerm}
          onChange={handleSearch}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      {filters.length > 0 && (
        <select
          value={selectedFilter}
          onChange={handleFilter}
          className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">{t('all')}</option>
          {filters.map(filter => (
            <option key={filter.value} value={filter.value}>
              {filter.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}